import React from 'react';
// import moment from 'moment';
import PnrFormComponent from '../pnr-form/pnr-form.component';
// models
import IDriverTrackingStatus from '../../models/driver-tracking-status.interface';
import ILocation from '../../models/location.interface';
import ITimeslot from '../../models/timeslot.interface';
import StatusList from '../status-list-component/status-list-component';
// styles
const styles = require('./driver-info.scss');
// images
// const logo = require('../../images/logo_airportr.svg');
const driverImgDefault = require('../../images/driver_default.jpg');

// const API_PATH = process.env.REACT_APP_API_URL;

interface IProps {
  locationData: ILocation;
  driverData: IDriverTrackingStatus;
  timeslotData: ITimeslot;
  locationType: string;
  queryParams: any;
  pnrBookingData: any;
  language: string;
  multiLang: any;
  airlineName: string;
  airlineCode: string;
  bagsJourney: any;
  completedTrackingStatus: any;
}

interface IState {
  location: ILocation;
  timeslot: ITimeslot;
  driver: IDriverTrackingStatus;
  driverImg: string;
  locationType: string;
  driverStatusCopy: Array<string>;
}

class DriverInfoComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      location: props.locationData,
      driver: props.driverData,
      driverImg:
        props.driverData.driverInfo.imageURL !== null
          ? props.driverData.driverInfo.imageURL
          : driverImgDefault,
      timeslot: props.timeslotData,
      locationType: props.locationType,
      driverStatusCopy: [
        'Driver has arrived',
        'Driver is running late',
        'Driver en-route',
        'Driver scheduled',
        'Driver scheduled',
        'Driver is running late',
        ' Driver scheduled',
      ],
    };
  }

  componentWillReceiveProps(props: IProps) {
    if (props.driverData !== null && props.timeslotData !== null) {
      this.setState({ driver: props.driverData });
      this.setState({
        driverImg:
          props.driverData.driverInfo.imageURL !== null
            ? props.driverData.driverInfo.imageURL
            : driverImgDefault,
      });
      this.setState({ timeslot: props.timeslotData });
    }
  }

  public render() {
    const {
      pnrBookingData,
      queryParams,
      language,
      multiLang,
      bagsJourney,
      completedTrackingStatus
    } = this.props;
    // const { driver } = this.state;

    // const message = driver.translation ? driver.translation.message : driver.message ? driver.message : '';
    // const parameters = driver.translation ? driver.translation.parameters : {};

    return (
      <div className={styles.mainContent}>
        <div className={styles.group}>
          <div>
            <h3>
              {multiLang[`yourDriverIsOnTheWayText${language}`]}
            </h3>

            <div className={styles.driver}>
              <img src={this.state.driverImg} />

              <div className={styles.driverInfo}>
                <p>{this.state.driver.driverInfo.name}</p>
                <p className={styles.textAccent}>
                  {
                    multiLang[
                    `${this.state.driverStatusCopy[
                    this.state.driver
                      .driverStatus - 1
                    ]
                    }${language}`
                    ]
                  }
                </p>

                <div>
                  <p className={styles.textMuted}>
                    {this.state.locationType ===
                      'collection'
                      ? multiLang[
                      `pickupAddressText${language}`
                      ]
                      : multiLang[
                      `deliveryAddressText${language}`
                      ]}
                  </p>
                  <p>
                    {multiLang[`Postcode${language}`]}:{' '}
                    {this.state.location.addressPostCode}
                  </p>
                </div>
              </div>
            </div>
            {pnrBookingData.showPNRField === true &&
              pnrBookingData.isPNRStored === false ? (
              <PnrFormComponent
                language={language}
                multiLang={multiLang}
                bookingReference={queryParams.bookingRef}
                emailAddress={queryParams.email}
                airlineCode={this.props.airlineCode}
                airlineName={this.props.airlineName}
              ></PnrFormComponent>
            ) : null}
          </div>

          <div>
            <StatusList
              bagsJourney={bagsJourney}
              multiLang={multiLang}
              language={language}
              completedTrackingStatus={completedTrackingStatus}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DriverInfoComponent;



// WEBPACK FOOTER //
// ./src/components/driver-info/driver-info.component.tsx